import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Dropdown} from '@udemy/react-menu-components';
import {
    AssessmentProductCard,
    CardActionMenu,
    CardDescription,
    CardTitle,
    RibbonTag,
    Tag,
    TagList,
} from '@udemy/react-product-card-components';

import {type AssessmentsCatalogQuery} from 'src/generated/graphql';

import {getTopicDomain} from './topic-icons';
import {stripHtml} from './utils';

export type BannerAssessment = NonNullable<
    NonNullable<AssessmentsCatalogQuery['assessments']>[number]
>;

interface AssessmentsBannerCardProps {
    assessment: BannerAssessment;
}

export const AssessmentsBannerCard: React.FC<AssessmentsBannerCardProps> = ({assessment}) => {
    const {gettext} = useI18n();
    const primaryTopic = assessment.topicDescriptors?.[0] ?? null;
    const topicDomain = getTopicDomain(primaryTopic?.id);
    const plainDescription = assessment.description ? stripHtml(assessment.description) : '';

    const tags: React.ReactElement[] = [];
    if (assessment.isBeta) {
        tags.push(<RibbonTag key="beta">Beta</RibbonTag>);
    }
    if (primaryTopic) {
        tags.push(<Tag key="topic">{primaryTopic.name}</Tag>);
    }

    return (
        <AssessmentProductCard
            layout="condensed"
            domain={topicDomain}
            stage="not-started"
            title={
                <CardTitle renderLink={CardTitle.renderAnchorTag({href: assessment.urlLanding})}>
                    {assessment.title}
                </CardTitle>
            }
            description={
                plainDescription ? <CardDescription>{plainDescription}</CardDescription> : undefined
            }
            tags={tags.length > 0 ? <TagList tags={tags} /> : undefined}
            iconButton={
                <CardActionMenu triggerLabel={gettext('More actions')}>
                    <Dropdown.MenuItem componentClass="a" href={assessment.urlLanding}>
                        {gettext('Start assessment')}
                    </Dropdown.MenuItem>
                </CardActionMenu>
            }
        />
    );
};
